/**
 * Data hook for the Operations Accepted book surface.
 *
 *   useAccepted() — polls GET /api/accepted every 15s. Read-only; the
 *   surface has no write path (chasing the FSA happens in Airtable/portal).
 *
 * 15-second polling matches the rest of the app (no websockets in v1).
 * The list is bounded (accepted-awaiting-FSA leads, a small set), so
 * refetching the whole thing is cheap.
 *
 * Spec: engineering/command-center/docs/port-notes/fishing.md (evicted 2026-08-29, #775 round 10)
 */

import { AcceptedResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useAccepted = createPollingQuery({
  queryKey: ["accepted"] as const,
  path: "/api/accepted",
  schema: AcceptedResponseSchema,
  refetchIntervalMs: 15_000,
});
